import { PaymentPack } from '@/interfaces/paymentPack';
import { PaymentPackResource, paymentPackResource } from '@/resources/paymentPack.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł paczek płatności
 *
 * @export
 * @class PaymentPackModule
 * @extends {EntityModule<PaymentPack, PaymentPackResource>}
 */
export class PaymentPackModule extends EntityModule<PaymentPack, PaymentPackResource> {
  constructor() {
    super(paymentPackResource);

    this.actions = {
      ...this.actions,

      /**
       * Zatwierdzenie paczki
       *
       * @param {*} context
       * @param {number} packId
       * @returns {Promise<boolean>}
       */
      confirm: (context: any, packId: number): Promise<boolean> => this.resource.confirm(packId),

      /**
       * Odtwierdzenie paczki
       *
       * @param {*} context
       * @param {number} packId
       * @returns {Promise<boolean>}
       */
      unconfirm: (context: any, packId: number): Promise<boolean> => this.resource.unconfirm(packId)
    };
  }
}

export default new PaymentPackModule();
